import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import Home from "./pages/Home";
import Checkout from './pages/Checkout';
import CheckoutComplete from './pages/CheckoutComplete';
import CreateAccount from './pages/CreateAccount';
import Login from './pages/Login';
import Membership from './pages/Membership';
import MembershipPayment from './pages/MembershipPayment';
import Session from './pages/Session';
import UserHome from './pages/UserHome';
import AdminHome from './pages/AdminHome';
import AdminVenueManagment from './pages/AdminVenueManagment';
import SessionManagement from "./pages/SessionManagement";
import Logout from "./pages/Logout";
import SessionList from "./pages/SessionList";
import Forgotten from "./pages/ForgottenPassword";
import Reset from "./pages/ResetPassword";
import GoCardlessComplete from "./pages/GoCardlessComplete";
import PublicClasses from "./pages/PublicClasses";
import PublicClassesDirectory from "./pages/PublicClassesDirectory";
import PlanManagement from "./pages/PlanManagement";
import MyPlans from "./pages/MyPlans";
import Reports from "./pages/Reports";
import UserAttendanceReport from "./pages/UserAttendanceReport";
import VenueAttendanceReport from "./pages/VenueAttendanceReport";
import SubscriptionOffers from "./pages/SubscriptionOffers";
import InviteSignUp from "./pages/InviteSignUp";
import Marketing from "./pages/Marketing";
import Plans from "./pages/Plans";
import FindPT from "./pages/FindPT";
import PTDirectorySignup from "./pages/PTDirectorySignup";
import PTProfile from "./pages/PTProfile";
//import VenueTokenSettings from "./pages/VenueTokenSettings";
import VenueSettings from "./pages/VenueSettings";

const AppRoutes = [
  {
    index: true,
    element: <Home />,
    private: false
  },
  {
    path: '/marketing',
    element: <Marketing />,
    private: false
  },
  {
    path: '/plans',
    element: <Plans />,
    private: false
  },
  {
    path: '/counter',
    element: <Counter />,
    private: true
  },
  {
    path: '/fetch-data',
    element: <FetchData />,
    private: true
  },
  {
    path: '/checkout',
    element: <Checkout />,
    private: false
  },
  {
    path: '/checkout-complete',
    element: <CheckoutComplete />
  },
  {
    path: '/create-account',
    element: <CreateAccount />,
    private: false
  },
  {
    path: '/login',
    element: <Login />,
    private: false
  },
  {
    path: '/forgotten-password',
    element: <Forgotten />,
    private: false
  },
  {
    path: '/reset-password',
    element: <Reset />,
    private: false
  },
  {
    path: '/logout',
    element: <Logout />,
    private: false
  },
  {
    path: '/membership',
    element: <Membership />,
    private: true
  },
  {
    path: '/membership-payment',
    element: <MembershipPayment />,
    private: true
  },
  {
    path: '/session',
    element: <Session />,
    private: true
  },
  {
    path: '/sessions',
    element: <SessionList />,
    private: true
  },
  {
    path: '/user-home',
    element: <UserHome />,
    private: true
  },
  {
    path: '/admin-home',
    element: <AdminHome />,
    private: true
  },
  {
    path: '/admin-venue-managment',
    element: <AdminVenueManagment/>,
    private: true
  },
  {
    path: 'admin-session-managment',
    element: <SessionManagement />,
    private: true
  },
  {
    path: '/admin-plan-management',
    element: <PlanManagement />,
    private: true
  },
  {
    path: '/my-plans',
    element: <MyPlans />,
    private: true
  },
  {
    path: '/admin-reports',
    element: <Reports />,
    private: true
  },
  {
    path: '/admin-reports/user-attendance',
    element: <UserAttendanceReport />,
    private: true
  },
  {
    path: '/admin-reports/venue-attendance',
    element: <VenueAttendanceReport />,
    private: true
  },
  {
    path: 'auth/gocardlesscomplete',
    element: <GoCardlessComplete />,
    private: false
  },
  {
    path: '/classes',
    element: <PublicClassesDirectory />,
    private: false
  },
  {
    path: '/classes/:venueId',
    element: <PublicClasses />,
    private: false
  },
  {
    path: '/admin-subscription-offers',
    element: <SubscriptionOffers />,
    private: true
  },
  {
    path: '/signup/invite/:inviteCode',
    element: <InviteSignUp />,
    private: false
  },
  {
    path: '/find-pt',
    element: <FindPT />,
    private: false
  },
  {
    path: '/pt/:slug',
    element: <PTProfile />,
    private: false
  },
  {
    path: '/pt-directory-signup',
    element: <PTDirectorySignup />,
    private: false
  },
  {
    path: '/venue-settings',
    element: <VenueSettings />,
    private: true
  }
];

export default AppRoutes;
